import React, { lazy } from 'react';
import { CheckIcon, CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const items = ['6 volumi didattici completi', '5 bonus strategici', '300+ sessioni pronte all’uso', '120+ schede tecniche visuali', 'Primaria e Secondaria', 'Accesso a vita al materiale digitale'];
export function PricingSection() {
  return <section id="offerta" className="bg-[#f4f8f5] px-5 py-20" data-id="element-140" data-mp="1nak9v0tlup5b">
      <div className="mx-auto max-w-xl text-center" data-id="element-141" data-mp="1naamlkzy2w3b">
        <p className="inline-block bg-[#09281d] px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-142" data-mp="1s93wl3g0w4yq">
          Offerta a tempo limitato
        </p>
        <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-none text-[#09281d] sm:text-5xl" data-id="element-143" data-mp="1x6vrm6bys775">
          Tutto incluso,{' '}
          <span className="text-emerald-700" data-id="element-144" data-mp="2vh29qmv89rx">un unico prezzo.</span>
        </h2>
        <p className="mt-3 text-sm font-semibold text-slate-600" data-id="element-145" data-mp="7tig9x5fpiwj">
          Nessun abbonamento. Nessuna sorpresa.
        </p>
        <article className="mt-10 overflow-hidden border border-emerald-950/10 bg-white text-center shadow-xl" data-id="element-146" data-mp="1mhq0ybk8hihd">
          <header className="border-t-4 border-emerald-500 bg-[#09281d] px-6 py-7" data-id="element-147" data-mp="1hp6fytj7vl2j">
            <h3 className="font-display text-3xl font-bold uppercase text-white" data-id="element-148" data-mp="1crwprbo075dn">
              EDUFIS PRONTO™ — Pacchetto completo
            </h3>
            <p className="mt-2 text-sm font-semibold text-emerald-300" data-id="element-149" data-mp="17pxny67wwgit">
              6 Volumi + 5 Bonus Strategici
            </p>
          </header>
          <div className="p-7 sm:p-10" data-id="element-150" data-mp="20hhde7v3qqt9">
            <img src="https://cdn.magicpatterns.com/uploads/p9hhkLxBL876TFK4Bo3VeE/Diseno-sin-titulo-2026-07-14T121316.486.webp" alt="Pacchetto completo EDUFIS PRONTO" width={1080} height={728} loading="lazy" className="mx-auto -mt-3 mb-3 w-full max-w-md object-contain" data-id="element-151" data-mp="20ecxid89y6mr" />
            <div id="dettagli-offerta" className="mb-8 scroll-mt-3 border-y border-emerald-950/10 py-7" data-id="element-152" data-mp="fzt7ujr6qfne">
              <p className="mb-5 text-xs font-bold uppercase tracking-widest text-[#09281d]" data-id="element-153" data-mp="mgum7koozffa">
                Cosa include
              </p>
              <ul className="grid gap-3 text-left sm:grid-cols-2" data-id="element-154" data-mp="7ik7po53lyph">
                {items.map(item => <li key={item} className="flex items-center gap-2 text-sm font-semibold text-[#09281d]" data-id="element-155" data-mp="chdi37p399lf">
                    <span className="grid h-5 w-5 place-items-center rounded-full bg-emerald-100" data-id="element-156" data-mp="3iif04hccfmc">
                      <CheckIcon className="h-3.5 w-3.5 text-emerald-700" data-id="element-157" data-mp="3kz0777dlffd4" />
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="mt-7" data-id="element-158" data-mp="3bxjxl1ulrh9y">
              <p className="text-sm font-semibold text-slate-600" data-id="element-159" data-mp="3bybrm88jx6y4">
                Valore totale: <s data-id="element-160" data-mp="3fy3v46j38mwm">€235</s>
              </p>
              <div className="mt-1 flex items-baseline justify-center text-[#09281d]" data-id="element-161" data-mp="3g185xmr26gw9">
                <span className="font-display text-5xl font-bold" data-id="element-162" data-mp="2xd7hzipo5oj9">€</span>
                <strong className="font-display text-8xl font-bold leading-none tracking-tight" data-id="element-163" data-mp="2sdl2t3qa5y7t">
                  19
                </strong>
              </div>
              <div className="mt-3 flex flex-wrap justify-center gap-3" data-id="element-164" data-mp="31c6rzhq9cbhk">
                <span className="bg-emerald-500 px-3 py-1.5 text-xs font-bold uppercase tracking-widest text-white" data-id="element-165" data-mp="31f1ah3ppnm8c">
                  Risparmi €216 — 92% di sconto
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-slate-600" data-id="element-166" data-mp="3b8rw80ugdikc">
                  Pagamento unico
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-slate-600" data-id="element-167" data-mp="3l1qp3uwzfv9r">
                  Accesso a vita
                </span>
              </div>
            </div>
            <a href="https://edufis-pronto.impultienda.ar/checkout" className="cta-button -mx-2 mt-6 block w-[calc(100%+1rem)] rounded-2xl px-6 py-6 text-xl font-bold sm:text-2xl" data-id="element-168" data-mp="3u2f34pmdlvmn">
              SÌ, VOGLIO EDUFIS PRONTO
            </a>
            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-slate-600" data-id="element-169" data-mp="qqnzi0is5hi8">
              <ShieldCheckIcon className="h-4 w-4 text-emerald-700" data-id="element-170" data-mp="vpqwcxolwhf4" /> Coperto
              dalla nostra garanzia soddisfatti o rimborsati di 7 giorni
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 border-t border-emerald-950/10 pt-6 text-xs font-bold text-slate-600" data-id="element-171" data-mp="3v6yvvlt46lxi">
              <span className="flex gap-1" data-id="element-172" data-mp="7z50s5vsgpm0">
                <LockKeyholeIcon className="h-4 w-4" data-id="element-173" data-mp="829bzn7o8lm6" /> Pagamento sicuro
              </span>
              <span className="flex gap-1" data-id="element-174" data-mp="cwn0d5nx1shc">
                <ZapIcon className="h-4 w-4" data-id="element-175" data-mp="1jfuzl3xvuf5l" /> Accesso immediato
              </span>
              <span className="flex gap-1" data-id="element-176" data-mp="1odn2su3z9np3">
                <CreditCardIcon className="h-4 w-4" data-id="element-177" data-mp="1oclidz12noup" /> Carta · Google Pay ·
                Apple Pay
              </span>
            </div>
          </div>
        </article>
        <p className="mt-5 text-xs font-semibold text-slate-600" data-id="element-178" data-mp="33wui35l8bdke">
          Prezzo finale in euro, pagamento una tantum e accesso immediato al
          materiale digitale.
        </p>
      </div>
    </section>;
}